module.exports = __webpack_public_path__ + "img/Youtube_music_icon.96a45779.png";